import { render, staticRenderFns } from "./FarmacieEditPage.vue?vue&type=template&id=6bc5160b"
import script from "./FarmacieEditPage.vue?vue&type=script&lang=js"
export * from "./FarmacieEditPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports